import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutCta() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-2xl overflow-hidden relative">
          <img
            src="https://readdy.ai/api/search-image?query=cat%20scratching%20board%20products%20arranged%20beautifully%20in%20a%20warm%20cozy%20home%20setting%2C%20natural%20light%2C%20warm%20beige%20and%20brown%20tones%2C%20lifestyle%20product%20photography%2C%20inviting%20atmosphere%2C%20minimalist%20composition&width=1200&height=400&seq=about-cta&orientation=landscape"
            alt="Koorpet Products"
            className="w-full h-56 md:h-72 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20"></div>
          <div className="absolute inset-0 flex flex-col items-start justify-center px-8 md:px-14">
            <p className="text-white/70 text-xs mb-2 tracking-widest uppercase">{t('about_cta_label')}</p>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-snug">
              {t('about_cta_title1')}<br />{t('about_cta_title2')}
            </h3>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/products"
                className="px-6 py-3 rounded-full bg-[#C8714A] text-white font-semibold text-sm hover:bg-[#b5603b] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-shopping-bag-line"></i>
                {t('about_cta_btn1')}
              </Link>
              <Link
                to="/contact"
                className="px-6 py-3 rounded-full border border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-mail-line"></i>
                {t('about_cta_btn2')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
